/* ============================================================
   MindPixels V2 — Animaciones del home (rediseño Figma)
   Reemplaza la animación de letras del hero anterior por
   reveals suaves al hacer scroll. Respeta prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  /* El contenido es visible por defecto en el CSS. Solo lo escondemos para
     animarlo si GSAP está realmente disponible; así, si el CDN falla o el
     usuario pidió menos movimiento, la página se ve completa igual. */
  var canAnimate =
    typeof gsap !== 'undefined' &&
    typeof ScrollTrigger !== 'undefined' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!canAnimate) return;

  gsap.registerPlugin(ScrollTrigger);

  function reveal(els, opts) {
    gsap.set(els, { opacity: 0, y: opts.y || 0, scale: opts.scale || 1 });
    gsap.to(els, {
      opacity: 1,
      y: 0,
      scale: 1,
      duration: opts.duration || 0.7,
      stagger: opts.stagger || 0,
      ease: 'power2.out',
      scrollTrigger: opts.trigger
        ? { trigger: opts.trigger, start: opts.start || 'top 85%', once: true }
        : undefined
    });
  }

  function init() {
    // Hero — entra al cargar, sin depender del scroll
    var heroText = document.querySelectorAll('.v2-hero__text > *');
    if (heroText.length) reveal(heroText, { y: 24, stagger: 0.09 });

    var heroMedia = document.querySelector('.v2-hero__media');
    if (heroMedia) reveal(heroMedia, { scale: 0.94, duration: 0.9 });

    var groups = [
      { sel: '.v2-highlight',     y: 16, stagger: 0.08 },
      { sel: '.v2-feature',       y: 30, stagger: 0.12 },
      { sel: '.v2-tool',          y: 40, stagger: 0.12 },
      { sel: '.v2-skills__image', y: 30, stagger: 0 },
      { sel: '.v2-skill',         y: 20, stagger: 0.07 },
      { sel: '.v2-member',        y: 30, stagger: 0.10 }
    ];

    groups.forEach(function (g) {
      var els = document.querySelectorAll(g.sel);
      if (!els.length) return;
      reveal(els, {
        y: g.y,
        stagger: g.stagger,
        trigger: els[0].closest('section, footer') || els[0],
        start: 'top 85%'
      });
    });

    var headings = document.querySelectorAll('.v2__heading, .v2-tools__title, .v2__eyebrow');
    headings.forEach(function (h) {
      reveal(h, { y: 20, trigger: h, start: 'top 92%' });
    });

    var banner = document.querySelector('.v2-video__banner-inner');
    if (banner) {
      reveal(banner, { y: 30, duration: 0.8, trigger: '.v2-video', start: 'top 70%' });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { ScrollTrigger.refresh(); }, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();